import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Product } from '../domain/product';
import { MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Router, ActivatedRoute } from '@angular/router';
import { IUser } from 'app/shared/Domains/IUser';
import { AuthService } from 'common/services/auth.service';
import { AppServiceManager } from 'common/services/appServiceManager';
import { ICompany } from 'app/shared/Domains/company';
import { IRole } from 'app/shared/Domains/role';
import { Configuration } from 'config/config';
import { NgxSpinnerService } from 'ngx-spinner';
import { IBranch } from 'app/shared/Domains/branch';
import { LanguageService } from 'app/LanguageService/Language.Service';

@Component({
  selector: 'app-products-listing',
  templateUrl: './products-listing.component.html',
  host: { "(window:keyup)": "hotkeys($event)" },
  styleUrls: ['./products-listing.component.css']
})
export class ProductsListingComponent implements OnInit {
  deleteConfirmationVisible = false;
  private pendingProductDeletion: any = null;
  @ViewChild("searchProduct", { static: false }) searchProductInput: ElementRef;
  tabIndex: number = 0;
  minQuantity: number;
  user: IUser;
  loading: boolean;
  products: any[];
  readyToSellProducts: any[];
  ingredientsBasedProducts: any[];
  ingredientsProducts: any[];
  product: Product;
  imgPreview: boolean = false;
  imgPreviewImg: any;
  sourceProducts: any[];
  sourceReadyToSellProducts: any[];
  sourceingredientsBasedProducts: any[];
  sourceingredientsProducts: any[];
  first: number = 0;
  company: ICompany;
  role: IRole;
  branch: IBranch;

  categoryFilter: string = '';

  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private activatedRoute: ActivatedRoute,
    public config: Configuration,
    private appServiceManager: AppServiceManager,
    private loader: NgxSpinnerService,
  ) {
    this.breadcrumbService.setItems([
      { label: 'Products Categories', routerLink: ['/product-categories'] },
      { label: 'Products' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("ProductsListingComponent", label);
  }
  ngOnInit() {
    this.user = AuthService.getLoggedInUser();
    this.role = AuthService.getLoggedInRole();
    this.company = new ICompany();
    // Refresh productImagePath from localStorage
    this.config.productImagePath = localStorage?.getItem('productImagePath');
    this.getCompany();
    this.getBranch();
    this.imgPreviewImg = "";
    this.products = [];
    this.product = new Product();
    // Fetch products and apply category filter if present in query params
    this.activatedRoute.queryParams.subscribe(params => {
      this.categoryFilter = params['category'] || '';
      if (this.categoryFilter) {
        this.breadcrumbService.setItems([
          { label: 'Products Categories', routerLink: ['/product-categories'] },
          { label: `${this.categoryFilter} Products` }
        ]);
      } else {
        this.breadcrumbService.setItems([
          { label: 'Products Categories', routerLink: ['/product-categories'] },
          { label: 'Products' }
        ]);
      }
      this.getProducts(this.categoryFilter);
    });
  }

  ngAfterViewInit() {
    this.searchProductInput.nativeElement.focus();
  }

  getCompany() {
    this.company = AuthService.getLoggedInCompanyBranch();
    if(!this.company){
      this.appServiceManager.get("companies/current").subscribe(
        (res) => {
          if (res) {
            this.company = res;
          } else {
            this.company = new ICompany();
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "Something Went Wrong",
            });
          }
        },
        (error) => {
          this.company = new ICompany();
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error,
          });
        }
      );
    }
  }
  getBranch() {
    this.branch = AuthService.getLoggedInCurrentBranch();
    if(!this.branch){
      this.appServiceManager.get('branches/' + this.user.branch).subscribe((res) => {
        if (res) {
          this.branch = res;
        } else {
          this.branch = new IBranch();
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
        }
      },
      (error) => {
        this.branch = new IBranch();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
    }
  }

  getProducts(categoryFilter?: string) {
    this.loading = true;
    this.loader.show();
    this.appServiceManager.get(`branches/${this.user.branch}/products`).subscribe((res: any) => {
      if (res.length > 0) {
        let fetchedProducts = res;
        // Apply category filter if passed from the Categories page
        if (categoryFilter) {
          fetchedProducts = fetchedProducts.filter(p => {
            const cat = typeof p.category === 'object' && p.category ? (p.category.name || p.category.code || '') : (p.category || '');
            return cat.toString().toLowerCase() === categoryFilter.toLowerCase() ||
                   (p.categoryId && p.categoryId.toString().toLowerCase() === categoryFilter.toLowerCase());
          });
        }
        fetchedProducts.sort((a: any, b: any) => {
    const dateA = Date.parse(a.createdOn) || 0;
    const dateB = Date.parse(b.createdOn) || 0;
    return dateB - dateA;
});
        this.products = fetchedProducts;
        this.sourceProducts = fetchedProducts;

        this.readyToSellProducts = this.products.filter(product => product.type == "Ready to Sell");
        this.sourceReadyToSellProducts = this.readyToSellProducts;

        this.ingredientsBasedProducts = this.products.filter(product => product.type == "Ingredients Based");
        this.sourceingredientsBasedProducts = this.ingredientsBasedProducts;

        this.ingredientsProducts = this.products.filter(product => product.type == "Ingredients");
        this.sourceingredientsProducts = this.ingredientsProducts;
        if (this.products.length === 0 && categoryFilter) {
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: `No Records Found for Category: ${categoryFilter}` });
        }
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
      this.loader.hide();
    },
      (error) => {
        this.loading = false;
        this.loader.hide();
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  //Status based filtering
  handleTabChange(e) {
    var index = e.index;
    if (index == 0) {
      this.tabIndex = 0;
    }
    if (index == 1) {
      this.tabIndex = 1;
    }
    if (index == 2) {
      this.tabIndex = 2;
    }
  }

  openPhoto(imgUri) {
    this.imgPreview = true;
    this.imgPreviewImg = imgUri;
  }

  getProductImageUrl(imagePath: string): string {
    if (!imagePath) {
      return 'assets/layout/images/gymSupplimentAvatar.png';
    }
    // If it's already a full URL or base64, return as is
    if (imagePath.startsWith('http') || imagePath.startsWith('data:image')) {
      return imagePath;
    }
    // If it's a default placeholder, return as is
    if (imagePath.includes('gymSupplimentAvatar.png') || imagePath.includes('assets/layout/images')) {
      return imagePath;
    }
    // Refresh config path from localStorage
    this.config.productImagePath = localStorage?.getItem('productImagePath');
    // If productImagePath is not set, try to construct it from user data
    if (!this.config.productImagePath && this.user) {
      this.config.productImagePath = `assets/layout/images/company_${this.user.company}/branch_${this.user.branch}/products/`;
    }
    if (this.config.productImagePath && this.config.Server) {
      // Ensure no double slashes
      const basePath = this.config.Server.endsWith('/') ? this.config.Server.slice(0, -1) : this.config.Server;
      return basePath + '/' + this.config.productImagePath + imagePath;
    }
    return 'assets/layout/images/gymSupplimentAvatar.png';
  }

  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  addProduct() {
    if (this.categoryFilter) {
      this.route.navigate(['/product'], { queryParams: { category: this.categoryFilter } });
    } else {
      this.route.navigate(['/product'], {
    queryParams: { from: 'products-listing' }
});
    }
  }

  viewProduct(product: any) {
    let category = this.categoryFilter;
    if (!category && product && product.category) {
      if (typeof product.category === 'object' && product.category !== null) {
        category = product.category.name || product.category.code || '';
      } else {
        category = String(product.category);
      }
    }
    if (category) {
      this.route.navigate(['/product', product._id], { queryParams: { category: category } });
    } else {
      this.route.navigateByUrl('product/' + product._id);
    }
  }

  deleteProduct(product) {
    this.pendingProductDeletion = product;
    this.deleteConfirmationVisible = true;
  }

  cancelProductDeletion() {
    this.deleteConfirmationVisible = false;
    this.pendingProductDeletion = null;
  }

  confirmProductDeletion() {
    const product = this.pendingProductDeletion;
    this.cancelProductDeletion();
    if (!product) return;

        this.loading = true;
        const branchId = AuthService.getLoggedInBranch() || this.user?.branch;
        this.appServiceManager.delete(`branches/${branchId}/products/${product._id}`).subscribe((res: any) => {
          if (res.status === true) {
            this.DeleteProduct(product);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.products = [...this.products]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
  }
  DeleteProduct(product) {
    let products = [...this.products];
    let index = this.products.indexOf(product);
    if (index > -1) {
      products.splice(index, 1);
      return this.products = products;
    }
  }

  searchLocal(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "" || !value) {
        this.products = Object.assign([], this.sourceProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.products = source.filter(distinct);

        if (this.products.length === 0) {
          this.products = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          this.products = [...this.products];
        }
      }
    } else {
      this.products = Object.assign([], this.sourceProducts);
      this.products = [...this.products];
    }
  }

  searchReadytoSell(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "" || !value) {
        this.readyToSellProducts = Object.assign([], this.sourceReadyToSellProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceReadyToSellProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.readyToSellProducts = source.filter(distinct);

        if (this.readyToSellProducts.length === 0) {
          this.readyToSellProducts = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          this.readyToSellProducts = [...this.readyToSellProducts];
        }
      }
    } else {
      this.readyToSellProducts = Object.assign([], this.sourceReadyToSellProducts);
      this.readyToSellProducts = [...this.readyToSellProducts];
    }
  }

  searchIngredientsBased(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "" || !value) {
        this.ingredientsBasedProducts = Object.assign([], this.sourceingredientsBasedProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceingredientsBasedProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.ingredientsBasedProducts = source.filter(distinct);

        if (this.ingredientsBasedProducts.length === 0) {
          this.ingredientsBasedProducts = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          this.ingredientsBasedProducts = [...this.ingredientsBasedProducts];
        }
      }
    } else {
      this.ingredientsBasedProducts = Object.assign([], this.sourceingredientsBasedProducts);
      this.ingredientsBasedProducts = [...this.ingredientsBasedProducts];
    }
  }

  searchIngredients(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "" || !value) {
        this.ingredientsProducts = Object.assign([], this.sourceingredientsProducts);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceingredientsProducts).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.ingredientsProducts = source.filter(distinct);

        if (this.ingredientsProducts.length === 0) {
          this.ingredientsProducts = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          this.ingredientsProducts = [...this.ingredientsProducts];
        }
      }
    } else {
      this.ingredientsProducts = Object.assign([], this.sourceingredientsProducts);
      this.ingredientsProducts = [...this.ingredientsProducts];
    }
  }

  clear() {
    this.product = new Product();
    this.searchLocal("", "");
    this.searchReadytoSell("", "");
    this.searchIngredientsBased("", "");
    this.searchIngredients("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }

  printProductsStockQuantity(): void {
    let printContents, popupWin;
    printContents = document.getElementById("overallProductsStockPrint").innerHTML;
    popupWin = window.open(
      "",
      "_blank",
      "top=0,left=0,height=100%,width=auto"
    );
    popupWin.document.open();
    popupWin.document.write(`
      <html>
      <head>
        <title>Gym Invoice</title>
        <style>
            .invoice-box {
                max-width: 800px;
                margin: auto;
                padding: 30px;
                border: 1px solid #eee;
                box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
                font-size: 16px;
                line-height: 24px;
                font-family: "Helvetica Neue", "Helvetica", Helvetica, Arial, sans-serif;
                color: #555;
            }
            .invoice-box table {
                width: 100%;
                line-height: inherit;
                text-align: left;
            }
            .invoice-box table td {
                padding: 5px;
                vertical-align: top;
            }
            .invoice-box table tr td:nth-child(n + 2) {
                text-align: right;
            }
            @media only screen and (max-width: 600px) {
                .invoice-box table tr.top table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
                .invoice-box table tr.information table td {
                    width: 100%;
                    display: block;
                    text-align: center;
                }
            }
        </style>
      </head>
      <body>${printContents}</body>
      </html>
    `);
  }

  hotkeys($event) {
    if ($event.keyCode == 113) {
      this.route.navigateByUrl("/product");
    }
  }
}